import React, { Component } from "react";
import { Parallax } from "react-parallax";

import { rangeMapper, clamp } from "../Utils/Functions";

export default class ModelSpecs extends Component {
  constructor(props) {
    super(props);
  }
  triggerModal(type = "rules") {
    this.props.modal(type);
  }
  calcReveal(percentage, delay = 0) {
    let calc = 0;
    delay = delay / 2;

    if (percentage < 1.7) {
      calc = clamp(
        rangeMapper(percentage, 1.4 + delay, 1.45 + delay, -250, 100),
        -250,
        0
      );
    }

    return calc;
  }

  calcRevealMove(percentage) {
    //console.log(percentage);
    const calc = clamp(rangeMapper(percentage, 1.2, 1.8, 50, -90), -900, 100);
    return calc;
  }

  render() {
    const { percentage, language } = this.props;
    return (
      <div className="modelSpecs">
        <div className="specs">
          {language === "et" ? (
            <>
              {" "}
              <div className="data">
                <div className="data--title">
                  487 <span className="data--units">km</span>
                </div>
                <div className="data--copy">Sõiduulatus (WLTP)</div>
              </div>
              <div className="data">
                <div className="data--title">
                  4,1 <span className="data--units">s</span>
                </div>
                <div className="data--copy">
                  Kiirendus&nbsp;0&nbsp;-&nbsp;100&nbsp;km/h
                </div>
              </div>
              <div className="data">
                <div className="data--title">
                  0 <span className="data--units">g/km</span>
                </div>
                <div className="data--copy">CO2-emissioon</div>
              </div>
            </>
          ) : (
            <>
              {" "}
              <div className="data">
                <div className="data--title">
                  487 <span className="data--units">км</span>
                </div>
                <div className="data--copy">Протяжённость поездки (до)</div>
              </div>
              <div className="data">
                <div className="data--title">
                  4,1 <span className="data--units">сек</span>
                </div>
                <div className="data--copy">
                  Ускорение&nbsp;0 &nbsp;-&nbsp;100&nbsp;км/час
                </div>
              </div>
              <div className="data">
                <div className="data--title">
                  0 <span className="data--units">гр/км</span>
                </div>
                <div className="data--copy">СО2&nbsp;-&nbsp;эмиссия</div>
              </div>
            </>
          )}
        </div>
      </div>
    );
  }
}

/*

465 км
Протяжённость поездки (до)
4,0 сек
Ускорение 0 - 100 км/час
0 гр/км
СО2 - эмиссия


465 km
Sõiduulatus (kuni)

 4,0 sek
Kiirendus 0 - 100 km/h

 0 g/km
 CO2-emissioon
*/
